<script lang="ts">
  import { formatEther } from "@ethersproject/units";

  import { getContext, onMount } from "svelte";
  import { Stretch } from "svelte-loading-spinners";

  import Content from "../../components/Content.svelte";
  import StakingHelpModal from "../../components/modals/StakingHelpModal.svelte";
  import StakingHelpArbitModal from "../../components/modals/StakingHelpArbitModal.svelte";
  import Page from "../../components/Page.svelte";
  import {
isArbitrum,
    lpTokenContract,
    networkName,
    shibContract,
    shibStakingContract,
    stakingContract,
    newStakingContract,
    tokenContract,
  } from "../../helpers/contracts";
  import { fetchPrice, fetchTokenPrice } from "../../helpers/price";
  import { formatNumbersWithCommas } from "../../helpers/string";
  import { ethereum, getBestProvider } from "../../store/ethereum";
  import Data from "../../components/Data.svelte";
  import CustomStakingCard from "../../components/staking/CustomStakingCard.svelte";
  import NftStakingCard from "../../components/staking/NFTStakingCard.svelte";
  import StakingCard from "../../components/staking/StakingCard.svelte";

  $: unsupportedNetwork =
    $ethereum.chainId !== 1 && $ethereum.chainId !== 42161;
  $: getTVL($ethereum);

  const { open } = getContext("simple-modal");

  let locked = 0;
  let staked = 0;
  let price = 0;
  let shibPrice = 0;
  let lpPrice = 0;

  const getTVL = async (e: any) => {
    setTimeout(async () => {
      try {
        await getPrices();

        if ($ethereum.chainId != 1) return;
        const _locked = await tokenContract($ethereum.chainId)
          .connect(getBestProvider($ethereum))
          .balanceOf(stakingContract($ethereum.chainId).address);
        const _staked = await stakingContract($ethereum.chainId)
          .connect(getBestProvider($ethereum))
          .totalSupply();

        staked = parseFloat(formatEther(_staked));
        locked = parseFloat(formatEther(_locked));
      } catch (err) {
        shibPrice = -1;
        price = -1;
        locked = -1;
        console.error(err);
      }
    }, 1000);
  };

  const getPrices = async () => {
    price = await fetchPrice();
    shibPrice = await fetchTokenPrice(
      "0x811beed0119b4afce20d2583eb608c6f7af1954f"
    );

    console.log("Shiba Price:", shibPrice);
    console.log("DOE Price:", price);
    if (isArbitrum($ethereum.chainId)) await getArbiPrices()
  };

  const getArbiPrices = async () => {
    const lpContract = lpTokenContract($ethereum.chainId).connect(
      $ethereum.signer
    );
    const _balanceRaw = await tokenContract($ethereum.chainId)
      .connect($ethereum.signer)
      .balanceOf(lpContract.address);

    const _totalSupplyRaw = await lpContract.totalSupply();
    const _balance = parseFloat(formatEther(_balanceRaw));
    const _totalSupply = parseFloat(formatEther(_totalSupplyRaw));

    lpPrice = ((_balance * 2) / _totalSupply) * price;
  };

  const openStakingHelp = () => {
    if (isArbitrum($ethereum.chainId)){
      open(StakingHelpArbitModal, {});
    }
    else {
      open(StakingHelpModal, {});
    }    
  };
</script>

<Page>
<div class="staking_outer">
  <div class="container">
    <div class="title-controls">
      <h1>Staking</h1>      
    </div>

    <div class="common_card_heading">
      <a href="/"> <i class="fas fa-arrow-left" /> Return home</a>
    </div>
    <div class="blue_card_common mb-3">
      <div class="text_left">
        <h3>Stake $DOE tokens to earn rewards.</h3>
        <p>Please be aware estimated APRs will likely drop over time as more
          people join the pool. More pools coming soon.
          <b>
            First you must approve your $DOE for use on the staking contract,
            then enter an amount and press stake.
          </b></p>
      </div>
      <div class="coinicon">
        <img src="img/images/green_dog_round.png" alt="logo">
      </div>
    </div>

    <div class="black-box">
      <div class="presale-info">        
        <a class="link_new" on:click={openStakingHelp}>How to stake?</a>
      </div>
    </div>

    <center class="tvl">
      {#if $ethereum.chainId === 1}
        {#if price > 0 && locked > 1}
          <div>
            <h1>
              TVL ${formatNumbersWithCommas(locked * price)}
            </h1>
            <p>
              With a total ${formatNumbersWithCommas(staked * price)} staked across
              all pools.
            </p>
          </div>
        {:else if price < 0 || locked < 0}
          <span />
        {:else}
          <Stretch size="50" color="#93cdbf" unit="px" duration="1s" />
        {/if}
      {/if}
    </center>

    <div class="network-info">
      <b>Connected Network:</b>
      {networkName($ethereum.chainId)} |
      <b>Connected Wallet:</b>
      <span class="tocken_number">{$ethereum.address ? $ethereum.address : "Not Connected"}</span>
    </div>
    
    <Data label="Token pools">
      <div class="staking">
        <div class="row">
        {#if unsupportedNetwork}
          <div class="error-alert">
            <h3>
              <i class="fas fa-exclamation-circle" />
              Unsupported network.
            </h3>
            Only Ethereum and Arbitrum network is currently supported.
            <br /> Please disconnect and re-connect your wallet with the appropriate
            network.
          </div>
        {:else if $ethereum.chainId === 1}
          <!-- <StakingCard /> -->
          <CustomStakingCard
            baseSymbol="DOE"
            rewardSymbol="DOE"
            rewardPrice={price}
            basePrice={price}
            baseToken={tokenContract($ethereum.chainId)}
            rewardToken={tokenContract($ethereum.chainId)}
            stakingContract={newStakingContract($ethereum.chainId)}
          />

          <CustomStakingCard
            baseSymbol="DOE"
            rewardSymbol="DOE Old"
            rewardPrice={price}
            basePrice={price}
            baseToken={tokenContract($ethereum.chainId)}
            rewardToken={tokenContract($ethereum.chainId)}
            stakingContract={stakingContract($ethereum.chainId)}
          />

          <CustomStakingCard
            baseSymbol="DOE"
            rewardSymbol="SHIB"
            rewardPrice={shibPrice}
            basePrice={price}
            baseToken={tokenContract($ethereum.chainId)}
            rewardToken={shibContract($ethereum.chainId)}
            stakingContract={shibStakingContract($ethereum.chainId)}
          />
        {:else if $ethereum.chainId === 42161}
          <CustomStakingCard
            baseSymbol="DOE-ETH SLP"
            rewardSymbol="DOE"
            rewardPrice={price}
            basePrice={lpPrice}
            rewardToken={tokenContract($ethereum.chainId)}
            baseToken={lpTokenContract($ethereum.chainId)}
            stakingContract={stakingContract($ethereum.chainId)}
          />
        {/if}
        </div>
      </div>
    </Data>

    
    {#if $ethereum.chainId === 1}
      <div class="row justify-content-center">
        
          <Data label="NFT pools">
            <div class="staking">
              {#if $ethereum.chainId === 1}
                <NftStakingCard />
              {/if}
            </div>
          </Data>
        
      </div>
    {/if}
  </div>
</div>
</Page>

<style>
  .staking_outer{
    background: #181826;
    padding:50px 0;
  }
  .black-box {
    flex-basis: 50%;
    margin-bottom: 20px;
  }

  .disclaimer {
    background: black;
    color: #fff;
    font-size: 0.8rem;
    max-width: 600px;
    border-radius: 10px;
    margin: 50px auto;
    padding: 20px;
  }

  .staking {
    max-width: 100%;
    width: 100%;
    margin: 40px auto;   
  }

  .coming-soon {
    cursor: default;
    max-width: 100%;
    padding: 20px;
    border-radius: 30px;
    background-color: var(--button-color);
    color: var(--button-text-color);
    width: 400px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .coming-soon h1 {
    margin: 0px;
  }

  .coming-soon-text {
    opacity: 0.5;
  }

  .error-alert {
    background-color: #fff;
    color: rgb(158, 25, 65);
    padding: 20px;
    border-radius: 15px;
  }

  .error-alert h3 {
    margin-top: 0rem;
    margin-bottom: 1rem;
  }

  .network-info {
    padding: 20px;
    border-radius: 20px;
    background-color: #232539;
    color: #fff;
    margin-bottom: 30px;
  }
  .tocken_number{
    word-break: break-word;
  }
  .network-info p {
    margin-bottom: 0;
  }

  .network-info .btn-link {
    color: white;
    opacity: 0.7;
    font-size: 0.9rem;
  }

  .tvl {
    padding: 20px 0px;
    padding-bottom: 40px;
  }

  .tvl h1 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .tvl p {
    margin-bottom: 0px;
    margin-top: 0px;
    opacity: 0.5;
  }

  a {
    cursor: pointer;
  }

  @media screen and (max-width: 600px) {
    .black-box {
      padding: 0px;
      transform: scale(1);
      margin-bottom: 20px;
    }

    .presale {
      width: 100%;
      padding: 10px;
      margin: 20px auto;
      /* transform: scale(1.1); */
    }

    .black-box h1 {
      font-size: 2rem;
    }

    h1 br {
      display: none;
    }

    .presale-info {
      padding: 20px;
    }

    .info {
      font-size: 0.7rem;
    }
  }
  .common_card_heading{
  padding: 15px 20px;
  background: #232539;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.common_card_heading a{
  margin-bottom: 0;
  color:#fff;
  text-decoration: none;
}


.blue_card_common{
  display: flex;
  align-items: center;
  padding: 30px;  
  background: #232539;
  margin-top: 7px;
}

.blue_card_common h3{
  font-size: 18px;
  margin-bottom: 15px;
}
.blue_card_common p{
  color:#a1a1a1;
  font-style: italic;  
  margin-bottom: 0;
  line-height: 21px;
}
.blue_card_common .coinicon{
  min-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.blue_card_common .coinicon img{
    height:111px;
}
@media (max-width:768px){
  .blue_card_common{
    flex-direction: column;
    padding: 15px;
  }
  .text_left{
    order:2;
    margin-top:15px;
  }
}
</style>
